<template>
  <Container type="card-full">
    <div class="name">项目名称：<span>{{project.projectname}}</span></div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            @cellClick="cellClick"  @cellDblClick="view"
            :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <vxe-button  icon="vxe-icon--plus" status="perfect" @click="addPg" :loading="btnLoading" v-if="showButton == 0">新增</vxe-button>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pqcIndex',
    data () {
      return {
        project: this.$route.params.form,
        isOperate:true,
        list: [],
        btnLoading: false,
        cols: [
          { type: 'seq',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'pqcitemchecktype', fieldtype: 'C', title: '初审类型',calculExpr:'',addNewRowFlg: false},
          { field: 'pqcitemcheckcontent', fieldtype: 'C', title: '初审内容',calculExpr:'',addNewRowFlg: false}
          // { field: 'pqcitemcheckdemand', fieldtype: 'C', title: '初审要求',calculExpr:'',addNewRowFlg: false}
        ],
        pqc: {},
        operateBtn:[
          {btncode:'CHG',btnicon:'el-icon-edit-outline',btnname:'修改'},
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        showButton:Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      }
    },
    created () {
      this.$on('CHG', () => this.chgPqc())
      this.$on('DEL', () => this.delpqc())
    },
    activated() {
      this.init()
      this.getpqcList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      // btnClick (code) {
      //   this.$emit(code)
      // },
      vggridClick(code,row){
        this.pqc = row
        this.$emit(code,row)
      },
      async init() {
      },
      async close() {
        let returnForm = 'projectIndex'
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      },
      async addPg () {
        if (this.project.projectstatus!=='10') {
          this.$message.error('项目公告已发布，不能新增评分项目！')
          return
        }
        let form = {
          pqcitemid: 0,
          pqcitemprojectid: this.project.projectid,
        }
        this.$router.push({name: 'pqcForm', params: {form: form, type: 1}})
      },
      async view () {
      },
      async cellClick (row) {
        this.pqc = row.row
      },
      async getpqcList () {
        this.loading = true
        let from = {}
        from.pqcitemprojectid = this.project.projectid
        let res = await request({
          method: 'get',
          url: '/ywgl/qcm/getpqclist',
          params: from
        })
        this.list = res
        this.loading = false
      },
      async chgPqc(){
        this.$router.push({name: 'pqcForm', params: {form: this.pqc, type: 1}})
      },
      async delpqc(){
          this.$confirm('确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let data = await request({
              url: '/ywgl/qcm/delpqc',
              method: "post",
              data: this.pqc
          })
          if (data.issuccess===1) {
            this.getpqcList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    },
    filters: {
    },
    computed: {
    }
  }
</script>
<style lang="scss">
  .name {
    padding-bottom: 10px;
    span {
      color: #999999;
    }
  }
</style>
